import ActivateRegistration from './ActivateRegistration';

export default ActivateRegistration;